import React from 'react'
import Layout from './Layout'
import ViewLog from '../../components/User/FollowUp/ViewLog'

export default function ViewLogPage() {
  return (
    <Layout><ViewLog /></Layout>
  )
}
